import { Title, Card, ButtonLink, AlertModal } from '@/components'

import { ACTIVE_USER, DELETE_COMMENT } from '@/queries'
import { useMutation } from '@apollo/client'

import { format, parseJSON } from 'date-fns'
import { AnimatePresence } from 'framer-motion'
import { useState } from 'react'

export const Comments = ({ comments = [] }: { comments: any[] }) => {
  const [commentToDelete, setCommentToDelete] = useState<any>()
  const [deleteCommentById] = useMutation(DELETE_COMMENT)

  const deleteCommentRequest = async () => {
    try {
      await deleteCommentById({
        variables: { commentId: commentToDelete },
        refetchQueries: [
          {
            query: ACTIVE_USER,
          },
        ],
      })

      setCommentToDelete(null)
    } catch (err) {
      console.log(err)
    }
  }
  return (
    <div className="px-4 sm:px-6 lg:px-8 pt-6 pb-16">
      <div className="sm:flex sm:items-center mb-2">
        <div className="sm:flex-auto">
          <Title as="h1" size="lg">
            Your Comments
          </Title>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        {comments.length ? (
          comments.map((comment) => (
            <div key={comment.id} className="col-span-1">
              <Card className="mt-4 relative">
                <p className="text-sm text-zinc-700 dark:text-zinc-200 tracking-tight font-semibold">
                  <time dateTime={format(parseJSON(comment.createdAt), 'MMM do, yyyy')}>
                    {format(parseJSON(comment.createdAt), 'MMM do, yyyy')}
                  </time>
                </p>
                <div
                  className="mt prose max-w-none text-zinc-700 dark:text-zinc-200 font-medium"
                  dangerouslySetInnerHTML={{ __html: comment.content }}
                />
                <div className="flex justify-end">
                  <ButtonLink
                    small
                    onClick={() => setCommentToDelete({ commentId: comment.id, reviewId: comment.reviewId })}
                  >
                    Delete
                  </ButtonLink>
                </div>
              </Card>
            </div>
          ))
        ) : (
          <div className="text-center col-span-2 mt-3 ">
            <div className="border-2 dark:border-zinc-600 border-zinc-400 border-dashed px-6 py-16 max-w-3xl rounded-lg mx-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="mx-auto h-12 w-12 text-brand"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
              </svg>

              <Title as="h3" size="lg">
                No Comments
              </Title>
            </div>
          </div>
        )}
      </div>
      <AnimatePresence>
        {commentToDelete ? (
          <AlertModal
            type="error"
            title="Are you sure you want to delete this comment?"
            description=""
            successMessage="Delete"
            cancelMessage="Cancel"
            handleCancel={() => setCommentToDelete(null)}
            handleSuccess={deleteCommentRequest}
          />
        ) : null}
      </AnimatePresence>
    </div>
  )
}
